import React from 'react';
import {Link} from 'react-router-dom';
import './Error.css';

function Error() {
  return (
    <div className='Error'>
      <div className='errorpage'>
        <h1>
          <Link
            to='/'
            className='linkLightBase'>
            Click here
          </Link>{' '}
          to return to main page
        </h1>
      </div>
    </div>
  );
}

export default Error;
